module.exports = __webpack_public_path__ + "img/系统应用2.5969880b.png";